
export const EmptySignInUsername = "EmptySignInUsername"
export const EmptySignInPassword = "EmptySignInPassword"
export const EmptyConfirmResetPasswordUsername = "EmptyConfirmResetPasswordUsername"
export const EmptyConfirmResetPasswordNewPassword = "EmptyConfirmResetPasswordNewPassword"
export const EmptyConfirmResetPasswordConfirmationCode = "EmptyConfirmResetPasswordConfirmationCode"
export const NotAuthorizedException = "NotAuthorizedException"
export const ExpiredCodeException = "ExpiredCodeException"
export const PasswordsDoNotMatch = "PasswordsDoNotMatch"
export const EmptyUpdatePassword = "EmptyUpdatePassword"
export const UsernameExistsException = "UsernameExistsException"
export const InvalidPasswordException = "InvalidPasswordException"
export const UnknownError = "UnknownError"

export const StepConfirmSignUp = "CONFIRM_SIGN_UP"
export const StepConfirmResetPassword = "CONFIRM_RESET_PASSWORD_WITH_CODE"
export const StepDone = "DONE"
export const StepConfirmSignInWithNewPasswordRequired = "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
